<template>
  <div class="chat-acquisition d-flex flex-wrap align-center ga-3">
    <v-btn
      color="primary"
      rounded="lg"
      :disabled="busy"
      @click="onPrepare"
    >
      {{ t('onboarding.wizard.chat-widgets.acquisition-prepare') }}
    </v-btn>
    <button
      type="button"
      class="chat-acquisition__skip text-caption font-weight-bold text-primary"
      :disabled="busy"
      @click="emit('skip')"
    >
      {{ t('onboarding.wizard.chat-widgets.acquisition-skip') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  busy?: boolean
}>()

const emit = defineEmits<{
  confirm: [payload: { contactsSource: string }]
  skip: []
}>()

const { t } = useI18n()

// Enable with a sensible default source (contacts already available in the app).
// The dedicated import / CRM-sync flows are configured later in the app.
const onPrepare = () => emit('confirm', { contactsSource: 'existing' })
</script>

<style scoped>
.chat-acquisition__skip {
  background: none;
  border: none;
  cursor: pointer;
  letter-spacing: 0.04em;
}
</style>
